// extracted by mini-css-extract-plugin
export default {"sliderContainer":"ArtifactsImages_sliderContainer__HlRe+","slideIco":"ArtifactsImages_slideIco__UoYCG","blur":"ArtifactsImages_blur__Y+XA1"};